require('./hireCardOpenYoungView.scss');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @actions
const hireCardOpenYoungActions = require('actions/hireCardOpenYoung');
const hireContactDataActions = require('actions/hireContactData');
const openYoungPersonalDataActions = require('actions/openYoungPersonalData');
const openYoungProfilesActions = require('actions/openYoungProfiles');
const shippingAddressAction = require('actions/shippingAddress');
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const mergePreContractualsPDF = require('actions/mergePreContractualsPDF');
const blockedAccountsAction = require('actions/blockedAccounts');
const precontractualDocumentMailAction = require('actions/precontractualDocumentsMailer');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const HireCardOpenYoungStep1 = require('components/hire/hireCardOpenYoung/hireCardOpenYoungStep1/hireCardOpenYoungStep1');
const HireCardOpenYoungStep2 = require('components/hire/hireCardOpenYoung/hireCardOpenYoungStep2/hireCardOpenYoungStep2');
const HireCardOpenYoungStep3 = require('components/hire/hireCardOpenYoung/hireCardOpenYoungStep3/hireCardOpenYoungStep3');
const HireCardOpenYoungStep4 = require('components/hire/hireCardOpenYoung/hireCardOpenYoungStep4/hireCardOpenYoungStep4');
const HireCardOpenYoungStep5 = require('components/hire/hireCardOpenYoung/hireCardOpenYoungStep5/hireCardOpenYoungStep5');
const HireCardOpenYoungStep6 = require('components/hire/hireCardOpenYoung/hireCardOpenYoungStep6/hireCardOpenYoungStep6');
const HireCardOpenYoungError = require('components/hire/hireCardOpenYoung/hireCardOpenYoungError/hireCardOpenYoungError');
const HireCardOpenYoungSuccess = require('components/hire/hireCardOpenYoung/hireCardOpenYoungSuccess/hireCardOpenYoungSuccess');

const HireCardSidebar = require('components/hire/hireCardSidebar/hireCardSidebar');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');

// @constants
const {
    FOURTH_STEP,
    REDIRECT_URL,
    WIZARD_FIRST_STEP,
    CARD_OPENYOUNG,
    OPENYOUNG_CARD_SUBTYPE,
    OPENYOUNG_CARD_TYPE,
    OPEN_YOUNG_KEY,
    FIRST_STEP
} = require('constants/index');
const { HIRE_CARD_PREPAY } = require('constants/operationCodesAccounts');
const { WEB_INACTIVE_ACCOUNT_ENABLED, ES_COUNTRY, MESSAGE_HIRE_24H } = require('constants/flagBasedFeatures');
const { catalogue, analyticsId } = require('../../components/hire/hireCardOpenYoung/analytics/hireCardOpenYoungAnalytics');

class HireCardOpenYoungView extends React.Component {
    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const {
            getshippingAddressList,
            match: { params: { redirect } },
            validateStep,
            getBlockedAccounts,
            immAccounts,
            resetPrecontractualDocumentMail
        } = this.props;
        resetPrecontractualDocumentMail();
        if (redirect === REDIRECT_URL) {
            validateStep(WIZARD_FIRST_STEP);
        }
        getshippingAddressList();
        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_CARD_PREPAY);
    }

    componentWillUnmount() {
        const {
            reset,
            resetBlockedAccounts,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props;

        reset();
        resetBlockedAccounts();
        resetTermsAndCondsText();

        if (__CONTACT_CENTER__) {
            resetPrecontractualMail();
        }
    }

    getProcessDetail() {
        return `${OPENYOUNG_CARD_TYPE}.${OPENYOUNG_CARD_SUBTYPE}`;
    }

    isReady() { // it warns the user if he's about to lose changes
        const { immHireCardOpenYoung } = this.props;
        let showPreLeaveModal = true;

        if (immHireCardOpenYoung.get('visibleStep') === 1) {
            showPreLeaveModal = false;
        }

        return showPreLeaveModal;
    }

    handleCancel() {
        this.props.history.push('/myprofile/cards');
    }

    buildWizardHiringSteps() {
        const {
            addAccount,
            fillOpenYoungPersonalData,
            fillOpenYoungProfile,
            getOpenYoungProfiles,
            handleAgreementCheckboxChange,
            handleAssociatedAccountChange,
            handleSelectExistingOpenyoung,
            handleTutorCheckboxChange,
            hireCardOpenYoung,
            immAccounts,
            immFlagBasedFeatures,
            immGlobalVariables,
            immHireCardImageSelector,
            immHireContactData,
            immHireInformation,
            immHiringProductInformation,
            immHireCardOpenYoung,
            immOpenYoungPersonalData,
            immOpenYoungProfileDetails,
            immOpenYoungProfiles,
            immOpenYoungTutorType,
            immPdfData,
            immPreContractualMail,
            immProfile,
            immShippingAddressList,
            loadUserContactData,
            requestPDFMerge,
            resetContactData,
            resetPersonalData,
            sendPrecontractualDocumentMail,
            sendPreContractualMail,
            setAllAccountsToInactive,
            setShippingAddress,
            setTermsAndCondsText,
            setVisibleStep,
            setWillCancel,
            validateStep,
        } = this.props;
        const wizardActions = {
            cancel: this.handleCancel,
            finish: hireCardOpenYoung,
            setVisibleStep,
            setWillCancel,
            validateStep
        };
        const showPreLeaveModal = this.isReady();
        const immSteps = immHireCardOpenYoung.get('steps');
        const immShippingAddress = immShippingAddressList.get('shippingAddress');
        let hasShippingAddress = true;

        const productName = this.getProcessDetail();
        const tealiumData = [
            catalogue[analyticsId.OPEN_YOUNG_CARD_STEP_1_VIEW]({ productName }),
            catalogue[analyticsId.OPEN_YOUNG_CARD_STEP_2_VIEW]({ productName }),
            catalogue[analyticsId.OPEN_YOUNG_CARD_STEP_3_VIEW]({ productName }),
            catalogue[analyticsId.OPEN_YOUNG_CARD_STEP_4_VIEW]({ productName }),
            catalogue[analyticsId.OPEN_YOUNG_CARD_STEP_5_VIEW]({ productName }),
            catalogue[analyticsId.OPEN_YOUNG_CARD_STEP_6_VIEW]({ productName }),
        ];
        const isShippingAddressButtonDisabled = !!immShippingAddressList && !immShippingAddressList.get('shippingAddressType') && immFlagBasedFeatures.get(ES_COUNTRY);
        const loadingFlag = immHireCardOpenYoung.get('loadingFlag');
        const immStep1 = immHireCardOpenYoung.getIn(['steps', FIRST_STEP]);

        return (
            <div>
                <div className="col-xs-12 col-md-8">
                    <Wizard
                        actions={wizardActions}
                        immSteps={immSteps}
                        showPreLeaveModal={showPreLeaveModal}
                        stepsAmount={immSteps.size}
                        tealium={tealiumData[immHireCardOpenYoung.get('visibleStep') - 1]}
                        visibleStep={immHireCardOpenYoung.get('visibleStep')}
                        isTaggingSecondVersion
                    >
                        <WizardStep
                            isLoading={loadingFlag}
                            cancelButton={true}
                            position="first"
                            nextButtonDisabled={__CONTACT_CENTER__ ? !immStep1.get('agreementChecked') : false}
                        >
                            <HireCardOpenYoungStep1
                                contractName="open-young"
                                flagBasedFeatures={immFlagBasedFeatures}
                                gestorCrossEnabled={immFlagBasedFeatures.get('web-gc-enabled')}
                                getOpenYoungProfiles={getOpenYoungProfiles}
                                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                hireCmsKey={CARD_OPENYOUNG}
                                immHireCardOpenYoung={immHireCardOpenYoung}
                                immHireInformation={immHireInformation}
                                immHiringProductInformation={immHiringProductInformation}
                                immOpenYoungProfiles={immOpenYoungProfiles}
                                immPreContractualMail={immPreContractualMail}
                                immProfileFields={immProfile}
                                requestPDFMerge={requestPDFMerge}
                                sendPreContractualMail={sendPreContractualMail}
                                setTermsAndCondsText={setTermsAndCondsText}
                            />
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            nextButtonDisabled={immHireCardImageSelector.get('isFetching')}
                            onBackClick={false}
                            position="middle"
                        >
                            <HireCardOpenYoungStep2
                                immHireCardImageSelector={immHireCardImageSelector}
                            />
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            onBackClick={false}
                            position="middle"
                        >
                            <HireCardOpenYoungStep3
                                addAccount={addAccount}
                                fillOpenYoungPersonalData={fillOpenYoungPersonalData}
                                fillOpenYoungProfile={fillOpenYoungProfile}
                                handleAccountChange={handleSelectExistingOpenyoung}
                                handleTutorCheckboxChange={handleTutorCheckboxChange}
                                immHireContactData={immHireContactData}
                                immHireCardOpenYoung={immHireCardOpenYoung}
                                immOpenYoungPersonalData={immOpenYoungPersonalData}
                                immOpenYoungProfileDetails={immOpenYoungProfileDetails}
                                immOpenYoungProfiles={immOpenYoungProfiles}
                                immOpenYoungTutorType={immOpenYoungTutorType}
                                loadUserContactData={loadUserContactData}
                                resetContactData={resetContactData}
                                resetPersonalData={resetPersonalData}
                            />
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            onBackClick={false}
                            position="middle"
                        >
                            <HireCardOpenYoungStep4
                                handleAssociatedAccountChange={handleAssociatedAccountChange}
                                immAccounts={immAccounts}
                                immHireCardOpenYoung={immHireCardOpenYoung}
                                isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                                setAllAccountsToInactive={setAllAccountsToInactive}
                            />
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            onBackClick={false}
                            position="middle"
                            nextButtonDisabled={isShippingAddressButtonDisabled}
                        >
                            <HireCardOpenYoungStep5
                                immHireContactData={immHireContactData}
                                immShippingAddressList={immShippingAddressList}
                                setShippingAddress={setShippingAddress}
                            />
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={true}
                            cancelButton={true}
                            immFinalButton="hireCardOpenYoung-hireCardOpenYoung_hire"
                            isLoading={immHireCardOpenYoung.get('isFetching')}
                            onBackClick={false}
                            position="last"
                            SignaturePatternButton={SignaturePatternButton}
                        >
                            <HireCardOpenYoungStep6
                                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                immAccounts={immAccounts}
                                immHireCardOpenYoung={immHireCardOpenYoung}
                                immOpenYoungPersonalData={immOpenYoungPersonalData}
                                immPdfData={immPdfData}
                                immShippingAddress={immShippingAddress}
                                selectedAccount={immSteps.getIn([FOURTH_STEP, 'accountId'])}
                                sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
                                setTermsAndCondsText={setTermsAndCondsText}
                            />
                        </WizardStep>
                    </Wizard>

                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                            <HireCardSidebar
                                immAccounts={immAccounts}
                                immGlobalVariables={immGlobalVariables}
                                immHireCardImageSelector={immHireCardImageSelector}
                                immHireContactData={immHireContactData}
                                immOpenYoungPersonalData={immOpenYoungPersonalData}
                                immShippingAddressList={immShippingAddressList}
                                immProfile={immProfile}
                                immAddress={immShippingAddress}
                                hasShippingAddress={hasShippingAddress}
                                selectedAccount={immSteps.getIn([FOURTH_STEP, 'accountId'])}
                                type={OPEN_YOUNG_KEY}
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack context="contracts" modifier="contracts-view" pageTitle={formatText('breadcrumb-cards')} hasEntrance={false}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildSuccessful() {
        const {
            immAccounts,
            immHireCardImageSelector,
            immHireCardOpenYoung,
            immHireContactData,
            immOpenYoungPersonalData,
            immProfile
        } = this.props;
        const selectedAccount = immHireCardOpenYoung.getIn(['steps', FOURTH_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);

        const processDetail = this.getProcessDetail();
        
        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <HireCardOpenYoungSuccess
                    immAccount={immAccount}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardOpenYoung={immHireCardOpenYoung}
                    immHireContactData={immHireContactData}
                    immOpenYoungPersonalData={immOpenYoungPersonalData}
                    immProfile={immProfile}
                    processDetail={processDetail}
                />
            </div>
        );
    }

    render() {
        const { immHireCardOpenYoung, immFlagBasedFeatures } = this.props;
        const pageTitle = getFinalTitle('hireCardOpenYoung-hireCardOpenYoung_pageTitle');
        const mappingBreadcrumb = [{
            text: formatText('breadcrumb-cards'),
            url: '/myprofile/cards'
        }, {
            text: formatText("hireCardOpenYoung-hireCardOpenYoung_breadcrumb")
        }
        ];

        const processDetail = this.getProcessDetail();

        let content;
        const hireRestrictionFlag = immHireCardOpenYoung.getIn(['steps', WIZARD_FIRST_STEP-1, 'hireRestriction']);
        const hireRestrictionFF = immFlagBasedFeatures.get(MESSAGE_HIRE_24H);
        if (immHireCardOpenYoung.get('isFetching')) {
            content = <LoadingSection />;
        } else if (immHireCardOpenYoung.get('error')) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardOpenYoungError
                        immHireCardOpenYoung={immHireCardOpenYoung}
                        processDetail={processDetail}
                    />
                </div>
            );
        } else if (hireRestrictionFlag && hireRestrictionFF) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardOpenYoungError
                        immHireCardOpenYoung={immHireCardOpenYoung}
                        processDetail={processDetail}
                        hireRestrictionFlag={hireRestrictionFlag}
                    />
                </div>
            );
        }else if (immHireCardOpenYoung.get('submitSuccessful')) {
            content = this.buildSuccessful();
        } else {
            content = this.buildWizardHiringSteps();
        }

        return (
            <div className="hire-card-open-young">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={pageTitle}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HireCardOpenYoungView.propTypes = {
    addAccount: PropTypes.func.isRequired,
    fillOpenYoungPersonalData: PropTypes.func.isRequired,
    fillOpenYoungProfile: PropTypes.func.isRequired,
    getOpenYoungProfiles: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func,
    getshippingAddressList: PropTypes.func,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    handleAssociatedAccountChange: PropTypes.func.isRequired,
    handleSelectExistingOpenyoung: PropTypes.func.isRequired,
    handleTutorCheckboxChange: PropTypes.func.isRequired,
    hireCardOpenYoung: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardOpenYoung: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immHiringProductInformation: PropTypes.object.isRequired,
    immOpenYoungPersonalData: PropTypes.object.isRequired,
    immOpenYoungProfileDetails: PropTypes.object.isRequired,
    immOpenYoungProfiles: PropTypes.object.isRequired,
    immOpenYoungTutorType: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequierd,
    immProfile: PropTypes.object.isRequierd,
    immShippingAddressList: PropTypes.object,
    loadUserContactData: PropTypes.func.isRequired,
    match: PropTypes.object,
    requestPDFMerge: PropTypes.func.isRequired,
    resetPrecontractualDocumentMail: PropTypes.func,
    reset: PropTypes.func.isRequired,
    resetContactData: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func,
    resetPersonalData: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setExistingOpenyoung: PropTypes.func.isRequired,
    setShippingAddress: PropTypes.func,
    setTermsAndCondsText: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired
};

module.exports.constructor = HireCardOpenYoungView;
module.exports.HireCardOpenYoungView = connect(
    state => ({
        immAccounts: state.accounts,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables,
        immHireCardImageSelector: state.hireCardImageSelector,
        immHireCardOpenYoung: state.hireCardOpenYoung,
        immHireContactData: state.hireContactData,
        immHireInformation: state.hireInformation,
        immHiringProductInformation: state.hiringProductInformation,
        immOpenYoungPersonalData: state.openYoungPersonalData,
        immOpenYoungProfileDetails: state.openYoungProfileDetails,
        immOpenYoungProfiles: state.openYoungProfiles,
        immOpenYoungTutorType: state.openYoungTutorType,
        immPdfData: state.precontractualsMergePdfs,
        immPreContractualMail: state.preContractualMail,
        immProfile: state.profile,
        immShippingAddressList: state.shippingAddress,
    }), {
        addAccount: hireCardOpenYoungActions.addAccount,
        fillOpenYoungPersonalData: openYoungPersonalDataActions.fillOpenYoungPersonalData,
        fillOpenYoungProfile: hireContactDataActions.fillOpenYoungProfile,
        getOpenYoungProfiles: openYoungProfilesActions.getOpenYoungProfiles,
        getshippingAddressList: shippingAddressAction.getShippingAddressList,
        getBlockedAccounts: blockedAccountsAction.getBlockedAccounts,
        handleAgreementCheckboxChange: hireCardOpenYoungActions.setAgreementCheckbox,
        handleAssociatedAccountChange: hireCardOpenYoungActions.setAssociatedAccount,
        handleSelectExistingOpenyoung: hireCardOpenYoungActions.selectExistingOpenyoung,
        handleTutorCheckboxChange: hireCardOpenYoungActions.toggleTutorCheckbox,
        hireCardOpenYoung: hireCardOpenYoungActions.hireCardOpenYoung,
        loadUserContactData: hireContactDataActions.loadUserData,
        requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
        reset: hireCardOpenYoungActions.reset,
        resetContactData: hireContactDataActions.reset,
        resetPersonalData: openYoungPersonalDataActions.reset,
        resetPrecontractualDocumentMail: precontractualDocumentMailAction.resetPrecontractualDocumentMail,
        resetBlockedAccounts: blockedAccountsAction.resetBlockedAccounts,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetTermsAndCondsText: termsAndCondsInfoActions.reset,
        sendPreContractualMail: preContractualMailActions.sendPreContractualMail,
        setAllAccountsToInactive: hireCardOpenYoungActions.setAllAccountsToInactive,
        setExistingOpenyoung: hireCardOpenYoungActions.setExistingOpenyoung,
        setShippingAddress: shippingAddressAction.setShippingAddress,
        setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
        setVisibleStep: hireCardOpenYoungActions.setVisibleStep,
        setWillCancel: hireCardOpenYoungActions.setWillCancel,
        sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
        validateStep: hireCardOpenYoungActions.validateStep
    }
)(withRouter(HireCardOpenYoungView));
